import React from 'react';
import PropTypes from 'prop-types';
import { PersonsOffshoreChartBase } from './PersonsOffshoreChart.styles';
import { PersonsOffshoreChartRowHeader } from './PersonsOffshoreChartRow/PersonsOffshoreChartRowHeader';
import { PersonsOffshoreChartVictory } from './PersonsOffshoreChartVictory';
import { WithScroller } from 'lib/components/Scroller/WithScroller';

export const PersonsOffshoreChart = ({ timelineData, chartWidth, theme, selectedDate }) => {
    const headerWidth = 110;
    const chartMinWidth = 1000;
    const chartMaxWidth = 2000;
    const useScroller = chartWidth <= chartMinWidth;
    const childChartWidth = useScroller ? chartMaxWidth : chartWidth;

    return (
        <PersonsOffshoreChartBase data-testid="persons-offshore-chart">
            <WithScroller useScroller={useScroller}>
                {() => (
                    <>
                        <PersonsOffshoreChartRowHeader width={headerWidth} chartWidth={childChartWidth} theme={theme} />
                        <PersonsOffshoreChartVictory
                            chartWidth={childChartWidth}
                            timelineData={timelineData}
                            selectedDate={selectedDate}
                            itemLabelWidth={headerWidth}
                            theme={theme}
                        />
                    </>
                )}
            </WithScroller>
        </PersonsOffshoreChartBase>
    );
};

PersonsOffshoreChart.displayName = 'PersonsOffshoreChart';

PersonsOffshoreChart.propTypes = {
    timelineData: PropTypes.array,
    selectedDate: PropTypes.object,
    chartWidth: PropTypes.number,
};

PersonsOffshoreChart.defaultProps = {};
